import React from "react";
import "./Menus.css";
import { Link } from "react-scroll";
const Menus = () => {
  return (
    <>
      <div className="nav-items">
        <div className="nav-item">
          <div className="nav-link">
            <Link
              to="home"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Home
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              About
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="projects"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Projects
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="work"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Work
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="blog"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Blog
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="techstack"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Tech Stack
            </Link>
          </div>
          <div className="nav-link">
            <Link
              to="achievements"
              spy={true}
              smooth={true}
              offset={-100}
              duration={100}
            >
              Achievements
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Menus;
